































































































































































































































import { Component, mixins, Prop, namespace } from 'nuxt-property-decorator'
import debounce from 'lodash/debounce'
import LazyHydrate from 'vue-lazy-hydration'
import VueScrollTo from 'vue-scrollto'
import MixinGeneral from '~/assets/mixins/general'
import { filterUrl } from '~/assets/filters/url'

const siteStore = namespace('site')

@Component({
  components: {
    LazyHydrate,
    ComponentPageProductsIdSectionMenu: () =>
      import(
        '~/components/pages/products/id/page-products-id-section-menu.vue'
      ),
    ComponentIntersect: () => import('~/components/intersect/intersect.vue'),
    ComponentHeaderWithLink: () =>
      import('~/components/header/header-with-link.vue'),
    ComponentProductItem1: () =>
      import('~/components/products/product-item-1.vue'),
    ComponentProductItem2: () =>
      import('~/components/products/product-item-2.vue'),
    ComponentProductSet: () => import('~/components/products/product-set.vue'),
    ComponentProductSetMobile: () =>
      import('~/components/products/product-set-mobile.vue'),
    ComponentReviewsPhotos: () =>
      import('~/components/reviews/photos-reviews.vue'),
    ComponentMobileReviewsPhotos: () =>
      import('~/components/mobile/reviews/m-photos-reviews.vue'),
    ComponentProductAdditionalWrapper: () =>
      import('~/components/products/product-additional-wrapper.vue'),
    ComponentHidingWrapper: () =>
      import('~/components/wrapper/hiding-wrapper.vue'),
    ComponentProductDescription: () =>
      import('~/components/products/description.vue'),
    ComponentProductParams: () => import('~/components/products/params.vue'),
    ComponentProductSpecificationNote: () =>
      import('~/components/products/product-specification-note.vue'),
    ComponentProductPackaging: () =>
      import('~/components/products/product-packaging.vue'),
    ComponentProductDocuments: () =>
      import('~/components/products/documents.vue'),
    ComponentProductAvailabilityStores: () =>
      import('~/components/products/product-availability-stores.vue'),
    ComponentProductAvailabilityStoresMap: () =>
      import('~/components/products/product-availability-stores-map.vue'),
    ComponentReviews: () => import('~/components/reviews/reviews.vue'),
    ComponentSeoFilters: () =>
      import('~/components/navigation/seo-filters.vue'),
  },
  filters: {
    filterUrl,
  },
})
export default class ComponentProductPageSections extends mixins(MixinGeneral) {
  @Prop({ type: Boolean, default: false }) readonly isMobileOrTablet!: boolean
  @Prop({ type: Number, required: true }) readonly id!: number
  @Prop({ default: null }) readonly entityId!: string | number
  @Prop({ type: Array, default: () => [] }) readonly sectionBlocks!: any[]
  @Prop({ default: null }) readonly collection!: any
  @Prop({ default: null }) readonly setData!: any
  @Prop({ default: null }) readonly kit!: any
  @Prop({ default: null }) readonly reviews!: any
  @Prop({ type: Object, default: () => ({ block1: [], block2: [] }) })
  readonly products!: { block1: any[]; block2: any[] }

  @Prop({ default: null }) readonly description!: any
  @Prop({ default: null }) readonly params!: any
  @Prop({ type: Boolean, default: false })
  readonly isShowSpecificationNote!: boolean

  @Prop({ type: Array, default: () => [] }) readonly packaging!: string[]
  @Prop({ default: null }) readonly documents!: any
  @Prop({ type: Boolean, default: false })
  readonly isShowAvailabilityStores!: boolean

  @Prop({ type: String, default: '' }) readonly productInStockViewType!: string
  @Prop({ default: null }) readonly unit!: string | null
  @Prop({ default: null }) readonly seoLinks!: any
  @Prop({ default: null }) readonly seo!: string | null

  @siteStore.Getter('getFixedHeaderHeight')
  readonly getFixedHeaderHeight!: number | null

  private isHideAvailabilityStores = false
  private activeSectionMenuItem: string | null = null
  private scrollHandler: any = null
  private mostVisibleSectionCode: string | null = null
  private maxVisiblePercentage = 0
  private styleSpacer!: Record<string, string>

  get classProducts() {
    return {
      [this.styleSpacer.mbGutter2]: !this.isMobileOrTablet,
      [this.styleSpacer.mbGutter]: this.isMobileOrTablet,
      [this.$style.products]: true,
      [this.$style.desktop]: !this.isMobileOrTablet,
      [this.$style.mobile]: this.isMobileOrTablet,
    }
  }

  get classMbGutter() {
    return {
      [this.styleSpacer.mbGutter2]: !this.isMobileOrTablet,
      [this.styleSpacer.mbGutter]: this.isMobileOrTablet,
    }
  }

  mounted() {
    if (this.sectionBlocks.length > 0 && !this.isMobileOrTablet) {
      setTimeout(() => {
        this.initObserverForSection()
      }, 250)
    }
  }

  beforeDestroy() {
    window.removeEventListener('scroll', this.scrollHandler)
  }

  goTo(code: string) {
    if (this.$refs[code]) {
      const fixedHeaderHeight = Number(this.getFixedHeaderHeight || 0)
      let offset = -1 * (24 + fixedHeaderHeight)
      if (this.isMobileOrTablet) {
        offset = -48
      }
      offset = offset - 57
      const el = (this.$refs[code] as any).$el
        ? ((this.$refs[code] as any).$el as HTMLElement)
        : (this.$refs[code] as HTMLElement)
      if (el) {
        ;(VueScrollTo as any).scrollTo(el, { offset, lazy: false })
      }
    }
  }

  private initObserverForSection() {
    const scrollHandler = debounce(() => {
      this.maxVisiblePercentage = 0
      this.sectionBlocks.forEach((item: any) => {
        this.checkSection(item)
        this.activeSectionMenuItem = this.mostVisibleSectionCode
      })
    }, 50)
    this.scrollHandler = scrollHandler
    window.addEventListener('scroll', scrollHandler)
  }

  private checkSection(item: any) {
    let sectionEl: HTMLElement | null = null
    if (this.$refs[item.code]) {
      if ((this.$refs[item.code] as any).$el) {
        sectionEl = (this.$refs[item.code] as any).$el as HTMLElement
      } else {
        sectionEl = this.$refs[item.code] as HTMLElement
      }
    }

    if (!sectionEl) return

    const rect = sectionEl.getBoundingClientRect()
    const visibleHeight =
      Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0)
    const visiblePercentage =
      Math.max(
        visibleHeight / window.innerHeight,
        visibleHeight / rect.height
      ) * 100

    if (
      visiblePercentage > 50 &&
      visiblePercentage > this.maxVisiblePercentage
    ) {
      this.maxVisiblePercentage = visiblePercentage
      this.mostVisibleSectionCode = item.code
    }
  }
}
